var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('welcome-component',{attrs:{"grey-background":true,"title":"Add New Client","newClientCreating":true}})}
var staticRenderFns = []

export { render, staticRenderFns }